import * as actions from '../actions';
import { CoreState } from '../types';

type Handler<A extends keyof typeof actions> = (
  state: CoreState,
  action: ReturnType<(typeof actions)[A]>,
) => CoreState;

export const setColor: Handler<'setColor'> = (state, action) => {
  return {
    ...state,
    color: action.payload,
  };
};
